
import { SpinEvent } from "@nolimitcity/slot-game/bin/core/spin/event/SpinEvent";
import { EventHandler } from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import { GameEvent } from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import { StageEvent } from "@nolimitcity/slot-game/bin/core/stage/event/StageEvent";
import { StageManager } from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import { PunkGameConfig } from "../../../PunkGameConfig";
import { PunkEngineManager } from "../../../punkEngine/PunkEngineManager";

export class ReelGraphicBackground extends PIXI.Graphics {

    private static _instance:ReelGraphicBackground;

    public static get instance():ReelGraphicBackground{
        return this._instance;
    }

    constructor(skipAble: boolean = false) {
        super();

        if(!ReelGraphicBackground._instance) ReelGraphicBackground._instance = this;
        else return;
            
        this.init();
        if (skipAble) {
            this.on('pointertap', () => EventHandler.dispatchEvent(new GameEvent(SpinEvent.SKIP)));
            this.interactive = true;
            this.buttonMode = false;
        }

        EventHandler.addEventListener(this, StageEvent.STAGE_RESIZED, (event:GameEvent) => this.onResize());
        StageManager.getLayer(PunkGameConfig.instance.LAYERS.REEL_OVERLAY.name).addChild(this);
    }

    protected init() {
        let w: number = (PunkGameConfig.instance.REEL_ENGINE_CONFIG.DIM.WIDTH + PunkGameConfig.instance.REEL_ENGINE_CONFIG.DIM.PADDING_X) * PunkGameConfig.instance.REEL_ENGINE_CONFIG.REEL_AMOUNT;
        let h: number = (PunkGameConfig.instance.REEL_ENGINE_CONFIG.DIM.HEIGHT + PunkGameConfig.instance.REEL_ENGINE_CONFIG.DIM.PADDING_Y);
        this.pivot.set(1, 1)
        this.reDraw(0, 0, w, h)
        this.alpha = 0;
    }

    protected reDraw(posX: number, posY: number, widht: number, height: number): void {
        this.clear();
        this.beginFill(0x000000, 1);
        this.drawRect(posX, posY, widht, height);
        this.endFill();
    }

    protected onResize(): void {
        this.position = PunkEngineManager.dim.position;
        this.scale = PunkEngineManager.dim.scale;
    }
}